import React from 'react';
import { M } from '@dashboard-experience/mastodon';
import PropTypes from 'prop-types';
import MatrixAddress from './MatrixAddress';
import { bestAvailableDisplayText } from './helpers';

function MatrixAddressContainer({ field, setField }) {
  if (!field) return null;

  return (
    <M.Container>
      <MatrixAddress
        label={bestAvailableDisplayText(field, 'displayTitle')}
        field={field}
        setField={setField}
        isInternational={Boolean(field.displayCommentInCandidatePortal)}
      />
    </M.Container>
  );
}

MatrixAddressContainer.propTypes = {
  field: PropTypes.object,
  setField: PropTypes.func.isRequired,
};

MatrixAddressContainer.defaultProps = {
  field: null,
};

export default MatrixAddressContainer;
